import React, { useMemo } from 'react'
import { MultiSelect } from '@workwave-tidal/core/components'
import Box from '@mui/material/Box'
import { ISalesTeam } from '@user/store/salesTeam'
import SalesTeamSelectItem from './SalesTeamSelectItem'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  label: string
  disabled: boolean
  onChange: (value: ISalesTeam[] | []) => void
  required?: boolean
  items: ISalesTeam[]
  value: ISalesTeam[] | []
  error?: boolean
  getOptionDisabled?: ((option: ISalesTeam) => boolean) | undefined
}

export default function SalesTeamSelect(props: Props) {
  const { items, onChange, value, error, ...rest } = props
  const tidalThemeActive = useTidalThemeActive()
  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  const sortedSalesTeams = useMemo(
    () =>
      items?.sort((a, b) =>
        b.name?.toLowerCase() > a.name?.toLowerCase() ? -1 : 1,
      ),
    [items],
  )

  return (
    <Box>
      <MultiSelect<ISalesTeam>
        {...rest}
        density={density}
        items={sortedSalesTeams}
        getLabel={(option) => option.name}
        required
        optionMode={'custom'}
        onChange={(value) => {
          onChange(value)
        }}
        value={value}
        error={error}
        inputMode="normal"
        maxSelectedItemsToShow={4}
        maxSelectedItemsToShowOnFocus={4}
        getOptionDisabled={(row) => {
          return row?.positions?.length == 0
        }}
        placeholder={
          value?.length > 4 ? 'of additional selected sales teams' : ''
        }
        renderOption={(props, option) => (
          <SalesTeamSelectItem props={props} option={option} />
        )}
      />
    </Box>
  )
}
